module.exports = __webpack_public_path__ + "img/pozar2.8513a032.jpg";